import { render } from "./VPaginator.vue?vue&type=template&id=06e75690&scoped=true"
import script from "./VPaginator.vue?vue&type=script&lang=js"
export * from "./VPaginator.vue?vue&type=script&lang=js"

import "./VPaginator.vue?vue&type=style&index=0&id=06e75690&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e75690"]])

export default __exports__